import styled from 'styled-components';

export const StickyHeader = styled.div`
  position: sticky;
  top: 0px;
  z-index: 100;
`;

export const SiteFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
`;

export const LoadingContainer = styled.div<{ isLoading: boolean }>`
  backdrop-filter: ${({ isLoading }) => (isLoading ? 'blur(3px)' : 'none')};
  position: absolute;
  z-index: 10;
  width: 100vw;
  min-height: 100%;
`;

export const LoadingWrapper = styled.div`
  margin-top: 5%;
`;
